<ta-lcl-auth-container>
  <div [ngSwitch]="loginMethod">
    <ta-flexbox justifyContent="center" class="w--100 pb--3">
      <h1 class="heading--1">Sign in to continue</h1>
    </ta-flexbox>

    <ng-template ngSwitchCase="tapad">
      <div class="pb--3">
        <ta-form-field
          label="Email"
          [errors]="validationResult?.errors?.nested?.email"
          [forceShowErrors]="forceShowErrors"
          [dirty]="loginForm.get('email')?.dirty"
          [uppercaseLabel]="true"
        >
          <ta-input
            type="email"
            [formControl]="loginForm.get('email')"
          ></ta-input>
        </ta-form-field>
      </div>

      <div class="pb--3">
        <ta-form-field
          label="Password"
          [errors]="validationResult?.errors?.nested?.password"
          [forceShowErrors]="forceShowErrors"
          [dirty]="loginForm.get('password')?.dirty"
          class="pb--3"
          [uppercaseLabel]="true"
        >
          <ta-input
            type="password"
            [formControl]="loginForm.get('password')"
          ></ta-input>
        </ta-form-field>
      </div>

      <ta-flexbox justifyContent="flex-end" class="pb--5 opacity--60">
        <ta-link
          routerLink="/forgot-password"
          [queryParams]="queryParams"
          [class.disabled]="loading"
          >{{ "Forgot Password?" | uppercase }}</ta-link
        >
      </ta-flexbox>

      <div [ngClass]="recaptchaWrapperClass">
        <ta-form-field
          [forceShowErrors]="forceShowErrors"
          [errors]="validationResult?.errors?.nested?.recaptchaResponse"
        >
          <ta-recaptcha
            (resolved)="setRecaptchaResponse($event)"
            (visible)="setRecaptchaWrapperClass($event)"
          ></ta-recaptcha>
        </ta-form-field>
      </div>

      <ta-link (taInteract)="loginMethod = undefined">
        <ta-icon icon="left-big"></ta-icon> {{ "Log in Options" | uppercase }}
      </ta-link>

      <ta-button
        (taInteract)="submitForm()"
        priority="primary"
        full
        [disabled]="lockedOutUntil != null"
        [tooltipShouldShow]="lockedOutUntil != null"
        [taTooltipStatic]="lockedOutTooltipMessage"
      >
        Sign In
      </ta-button>
    </ng-template>

    <ng-template ngSwitchDefault>
      <div class="padding-top-4">
        <div class="pb--3">
          <ta-button
            priority="primary"
            full
            (taInteract)="loginMethod = 'tapad'"
          >
            {{ "Sign in with Tapad" | uppercase }}
          </ta-button>
        </div>

        <div
          class="w--100"
          id="google-sign-in-container"
          #googleSignInContainer
        ></div>
        <div
          class="w--100"
          id="google-sign-in-mobile-container"
          #googleSignInMobileContainer
        ></div>
      </div>
    </ng-template>
  </div>
</ta-lcl-auth-container>
